<template>
  <div>
    <!-- <v-card shaped elevation="12" outlined>
      <v-list-item three-line> -->
    <v-autocomplete
      prepend-inner-icon="search"
      v-model="selectedClass"
      :items="classes"
      item-text="class_name"
      item-value="class_name"
      flat
      hide-details
      :label="label || 'Select Class'"
      @change="getSelectedClass()"
    ></v-autocomplete>
    <!-- </v-list-item>
    </v-card> -->
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["label"],
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  mounted() {
    axios
      .getData("/auth/get-all-classes", this.getAccessToken)
      .then((classes) => {
        this.classes = classes;
      });
  },
  data: () => ({ classes: [], selectedClass: null }),
  methods: {
    getSelectedClass() {
      this.$emit("selected-class", this.selectedClass);
    },
  },
};
</script>

<style></style>
